import {Quantity} from "../../common/models/quantity.model"
export const checkQuantity = (selectedItems: number) => {
    if (selectedItems === 0) {
      return Quantity.NONE;
    } else if (selectedItems === 1) {
      return Quantity.ONE;
    } else {
      return Quantity.MANY;
    }
  };